export const CUSTOM_RETENTION_UNIT = `custom`;
